<div class="relative z-0 mb-4 flex flex-wrap items-start justify-between gap-4">
	<div class="text-base font-bold text-black">Ratings List</div>
	<app-cbta-daterange-filter
		[startDate]="startDate"
		[endDate]="endDate"
		[enabled]="dateFilterEnabled"
		(dateRangeSelected)="handleDateRangeChange($event)"
	></app-cbta-daterange-filter>
</div>

<!-- Forms List -->
<div class="cbta-tbl forms-tbl">
	<div class="columns">
		<div class="column col-12">
			<ngx-table
				[configuration]="configuration"
				[data]="forms"
				[noResultsTemplate]="noResultsTemplate"
				[columns]="columns"
				[pagination]="pagination"
				(event)="onTableChanged($event)"
			>
			</ngx-table>
		</div>

		<ng-template #trainingNameTpl let-row let-rowIndex="rowIndex">
			<span class="font-bold">{{ row.name }}</span>
		</ng-template>

		<ng-template #formTypeTpl let-row let-rowIndex="rowIndex">
			<span class="font-bold">{{ row.formTypeLabel }}</span>
		</ng-template>

		<ng-template #sessionTpl let-row let-rowIndex="rowIndex">
			<span>{{ getSessionConfig(row.sessionConfig) }}</span>
		</ng-template>

		<ng-template #dateTpl let-row let-rowIndex="rowIndex">
			<span class="text-violet">{{ formatDate(row.updatedDate) }}</span>
		</ng-template>

		<ng-template #actionTpl let-row let-rowIndex="rowIndex">
			<button
				class="aa-btn mx-auto capitalize"
				data-size="small"
				data-variant="secondary"
				(click)="goToRatingForm(row.id)"
			>
				{{ isOnline ? "rating" : "offline rating" }}
			</button>
		</ng-template>

		<ng-template #noResultsTemplate>
			<td [attr.colspan]="columns.length" class="h-[180px] text-center">
				<span class="text-grey-40">No results found.</span>
			</td>
		</ng-template>
	</div>
</div>
